import React from "react";
import { useNavigate } from "react-router-dom";

function cardStyle(accent) {
  return {
    width: "min(680px, 100%)",
    borderRadius: 24,
    padding: "32px 28px",
    background: "#fffdf8",
    border: `1px solid ${accent}`,
    boxShadow: "0 24px 60px rgba(44, 62, 80, 0.12)",
  };
}

export default function PaymentResultPage({
  kind = "success",
  title,
  message,
  hint,
}) {
  const navigate = useNavigate();
  const isSuccess = kind === "success";
  const accent = isSuccess ? "#98c379" : "#f2b880";
  const badgeBg = isSuccess ? "#e9f7df" : "#fff3e5";
  const badgeColor = isSuccess ? "#2f6b2f" : "#8a4b08";

  return (
    <section
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: 24,
        background:
          "radial-gradient(circle at top, rgba(255, 214, 102, 0.32), transparent 35%), linear-gradient(180deg, #fff8ec 0%, #f7f3ea 100%)",
      }}
    >
      <div style={cardStyle(accent)}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            padding: "8px 14px",
            borderRadius: 999,
            background: badgeBg,
            color: badgeColor,
            fontWeight: 800,
            marginBottom: 18,
          }}
        >
          <span>{isSuccess ? "Paiement confirmé" : "Paiement interrompu"}</span>
        </div>

        <h1 style={{ margin: 0, fontSize: "clamp(2rem, 4vw, 3rem)", lineHeight: 1.05, color: "#1d1d1f" }}>
          {title}
        </h1>

        <p style={{ marginTop: 14, marginBottom: 0, fontSize: 18, lineHeight: 1.6, color: "#3d3d44" }}>
          {message}
        </p>

        <p style={{ marginTop: 12, marginBottom: 0, fontSize: 15, lineHeight: 1.6, color: "#6b6b75" }}>
          {hint}
        </p>

        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 28 }}>
          <button
            type="button"
            onClick={() => navigate("/app/projects")}
            style={{
              border: "none",
              borderRadius: 14,
              padding: "14px 18px",
              background: "#1d1d1f",
              color: "#fff",
              fontWeight: 800,
              cursor: "pointer",
            }}
          >
            Aller à mon espace
          </button>

          <button
            type="button"
            onClick={() => navigate("/app/quotes")}
            style={{
              borderRadius: 14,
              padding: "14px 18px",
              background: "transparent",
              color: "#1d1d1f",
              border: "1px solid rgba(29,29,31,0.16)",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Voir mes devis
          </button>
        </div>
      </div>
    </section>
  );
}

